import React from 'react';
import ReactDOM from 'react-dom/client';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/schedule/styles.css';
import '@mantine/notifications/styles.css';
import 'dayjs/locale/fr';
import App from './App';
import './index.css';
import { suppressResizeObserverLoopError } from './lib/suppressResizeObserverLoopError';

dayjs.extend(customParseFormat);
suppressResizeObserverLoopError();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
